'use client';

import {usePathname} from 'next/navigation';
import {useEffect} from 'react';

import {authDoneStates, useAuthProgressState} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';

export const PageViewReporter = () => {
  const pathname = usePathname();
  const authState = useAuthProgressState();

  useEffect(() => {
    if (authDoneStates.includes(authState)) {
      logTmrEvent({logEvent: 'webVitrina.view'});
    }
  }, [pathname, authState]);

  return null;
};
